import React from "react";
import PolicyLayout from "./PolicyLayout";

function Returns() {
  return (
    <PolicyLayout
      title="Return, refund and exchange policy"
      intro="This procedure covers products bought through this storefront and separates product-problem remedies from preference-based requests."
    >
      <section>
        <h2>Start every request before sending goods</h2>
        <p>Email the order number, product name, reason and requested outcome. For a fault or incorrect supply, add photographs that show the condition, packaging and delivery label. Wait for written return instructions; a parcel sent without an identifiable order or authorised route may not be capable of safe receipt or matching.</p>
      </section>

      <section>
        <h2>Faulty, unsafe, damaged or incorrect goods</h2>
        <p>Stop using an item that is cracked, leaking, contaminated, electrically damaged, missing a safety component or materially inconsistent with its description. The evidence is assessed against the product listing, delivered label, parcel condition and stated use. An approved remedy may be a replacement from available stock, completion of missing supply, a proportionate refund or a full refund through the original payment route.</p>
        <p>Where returning the item would create a glass, liquid, food or electrical hazard, follow the safe disposal or collection instruction supplied during the assessment. Mandatory rights for unsafe, falsely described or otherwise non-conforming goods are not reduced by product category.</p>
      </section>

      <section>
        <h2>Preference-based return or exchange request</h2>
        <p>A request based only on preference must be made before the product is used, washed, attached, altered, consumed or opened beyond inspection. The item must remain complete with seals, labels, accessories and protective packaging. Approval is required before return, and the customer is responsible for protective return transport unless a mandatory rule says otherwise.</p>
        <p>A request to swap colour, size or product is assessed under the same unused-condition test and depends on the requested stock being available. Sending back one item does not reserve another. Any price difference and the approved shipping arrangement are confirmed before an exchange proceeds.</p>
      </section>

      <section>
        <h2>Category-specific condition rules</h2>
        <ul>
          <li>Food, tea, carbonated drinks and spirits cannot be accepted for preference reasons after the seal or primary pack is opened.</li>
          <li>Tableware, glass, mirrors and candle pieces must be packed to prevent movement and sharp-fragment exposure.</li>
          <li>Pins and patches must not have pierced, adhered to or been stitched onto a surface; textiles must be unworn, unwashed and unmarked.</li>
          <li>Lamps must be unmodified, dry and complete with supplied components; damage caused by incompatible power or altered wiring is not a delivery fault.</li>
          <li>Expected glaze, grain, weave, fibre or hand-finish differences described before purchase are not defects by themselves.</li>
        </ul>
      </section>

      <section>
        <h2>Inspection and refund route</h2>
        <p>An authorised return is checked against the stated reason and condition. The decision is sent to the purchaser's email. An approved refund is submitted to the original payment route; the card issuer or payment service controls when the credit appears after submission. Only the accepted products and any shipping amount required by a mandatory rule are included.</p>
      </section>
    </PolicyLayout>
  );
}

export default Returns;
